import { isEmpty } from 'validations';

export const validateBenefit = (article) => {
	let isValid = true;
	let messages = [];

	if (isEmpty(article.title)) {
		isValid = false;
		messages.push('Title is required');
	}

	if (isEmpty(article.subtitle)) {
		isValid = false;
		messages.push('Subtitle is required');
	}

	if (isEmpty(article.body)) {
		isValid = false;
		messages.push('Article body is required');
	}

	if (isEmpty(article.category)) {
		isValid = false;
		messages.push('Category is required');
	}

	let validation = {
		isValid,
		messages
	};

	return validation;
};
